const commentsConfig = {
  sort_name: "comments_sort",
};

export default commentsConfig;
